import makeApiCall from "./master/axiosIndex";
// TO DO Update endpoints
export const documentApis = {
  listDocuments: (params: any): Promise<any> =>
    makeApiCall({
      url: `dms/docsListPagination`,
      method: "get",
      params,
    }),
  projectList: (params: any): Promise<any> =>
    makeApiCall({
      url: `project/dropdown`,
      method: "get",
      params,
    }),
  phaseList: (params: any): Promise<any> =>
    makeApiCall({
      url: `phase/dropdown`,
      method: "get",
      params,
    }),
  uploadDocument: (data: any): Promise<any> =>
    makeApiCall({ url: "/dms/upload-multi", method: "post", data }),
  fetchTaskDropDown: (params: any): Promise<any> =>
    makeApiCall({
      url: `/task/dropdown`,
      method: "get",
      params,
    }),
  fetchActivityDropDown: (params: any): Promise<any> =>
    makeApiCall({
      url: `/activity/dropdown`,
      method: "get",
      params,
    }),
  fetchIssueDropDown: (params: any): Promise<any> =>
    makeApiCall({
      url: `/issue/dropdownList`,
      method: "get",
      params,
    }),
};
